import { AuthContext } from "../context/authContext"
import { useContext } from "react"

export default function AdminContainer ({children, rols = []}){
    const {user, loading} = useContext(AuthContext)

    if (loading) return null
    if (!rols.some(rol => user?.rol_user === rol)) return null

    return children
}